import React from 'react';
import PropTypes from 'prop-types';
import { trackEvent } from '@nexus/fff-analytics';

import { getImageByScreenMode } from '../../helpers/images';
import './HeroBanner.css';

const HeroBanner = ({ screenMode, data }) => (
  <section
    className="hero-banner"
    style={{ backgroundImage: `url(${getImageByScreenMode(data, screenMode, 'BackgroundImageURL')})` }}
  >
    <div className="hero-banner__container">
      <div className="hero-banner__image">
        <img src={getImageByScreenMode(data, screenMode, 'ForegroundImageURL')} alt="Foreground" />
      </div>
      <div className="hero-banner__info__cta">
        <div className="hero-banner__info">
          {data.title && (
            <div className="hero-banner__info__title">
              <h3>{data.title}</h3>
            </div>
          )}
          {data.subText && (
            <div className="hero-banner__info__subText">
              {data.subText}
            </div>
          )}
        </div>
        <div className="hero-banner__cta">
          <div className="hero-banner__cta__btn">
            <a
              className="fff-btn-black-small"
              onClick={() => trackEvent(data.ctaLabel1)}
              href={data.ctaLink1}
            >
              {data.ctaLabel1}
            </a>
          </div>
          {data.ctaLink2 && data.ctaLabel2 && (
            <div className="hero-banner__cta__btn">
              <a
                className="fff-btn-black-outline-small"
                onClick={() => trackEvent(data.ctaLabel2)}
                href={data.ctaLink2}
              >
                {data.ctaLabel2}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  </section>
);

HeroBanner.defaultProps = {
  screenMode: 'mobile',
  data: {},
};

HeroBanner.propTypes = {
  screenMode: PropTypes.string,
  data: PropTypes.shape({
    title: PropTypes.string,
    subText: PropTypes.string,
    desktopBackgroundImage: PropTypes.string,
    tabletBackgroundImage: PropTypes.string,
    mobileBackgroundImage: PropTypes.string,
    desktopForegroundImage: PropTypes.string,
    tabletForegroundImage: PropTypes.string,
    mobileForegroundImage: PropTypes.string,
    ctaLink1: PropTypes.string,
    ctaLabel1: PropTypes.string,
    ctaLink2: PropTypes.string,
    ctaLabel2: PropTypes.string,
  }),
};

export default HeroBanner;
